<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/AdministrativeLocations">Administrative Locations</b-breadcrumb-item>
            <b-breadcrumb-item active>Add</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Create New Adloc</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4 col-sm-12 form-group">
                            <label for="Id">Number</label>
                            <input :class="{'is-invalid': $v.administrativeLocation.id.$invalid}" autocomplete="off"
                                   class="form-control"
                                   placeholder="Number"
                                   v-model.lazy="administrativeLocation.id"/>
                            <span class="invalid-feedback"
                                  v-if="!$v.administrativeLocation.id.required">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.administrativeLocation.id.isUnique">The input number already exists</span>
                            <span class="invalid-feedback" v-if="!$v.administrativeLocation.id.minLength">Number must be &ge; 7 characters</span>
                            <span class="invalid-feedback" v-if="!$v.administrativeLocation.id.maxLength">Number must be &le; 9 characters</span>
                        </div>
                        <div class="col-md-8 col-sm-12 form-group">
                            <label for="Description">Description</label>
                            <input :class="{'is-invalid': $v.administrativeLocation.description.$invalid}"
                                   class="form-control"
                                   maxlength="60"
                                   placeholder="Description" v-model="administrativeLocation.description"/>
                            <span class="invalid-feedback" v-if="!$v.administrativeLocation.description.required">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.administrativeLocation.description.maxLength">Description must be &le; 60 characters</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'AdministrativeLocations'}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>


    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AdministrativeLocationService from "@/services/AdministrativeLocationService";
    import {maxLength, minLength, required} from "vuelidate/lib/validators";

    export default {
        components: {},
        data() {
            return {
                administrativeLocation: {
                    id: null,
                    description: null
                },
                isSubmitting: false,
            }
        },
        methods: {
            /**
             * @description Updates an adloc and redirects if successful
             */
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                AdministrativeLocationService.addAdministrativeLocation(vm.administrativeLocation).then(() => {
                    vm.alert(ToastType.Success, `The adloc '${vm.administrativeLocation.id}' was successfully created.`);

                    // Redirect to the adlocs page
                    vm.$router.replace({name: 'AdministrativeLocations'})
                }).catch(function (error) {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        validations: {
            administrativeLocation: {
                id: {
                    required,
                    maxLength: maxLength(9),
                    minLength: minLength(7),
                    isUnique(value) {
                        if (!value) return true;

                        return AdministrativeLocationService.getAdministrativeLocation(value)
                            .then(() => false)
                            .catch((error) => {
                                // If we get a "Not Found" we know that it is unique
                                return error.response.status === 404;

                            })
                    }
                },
                description: {
                    required,
                    maxLength: maxLength(60)
                },
            }
        }
    }
</script>
